// "Now" and "today" for the maths. The old app used the device's clock and local date; v2 does the
// same in the browser. Server jobs set the time zone explicitly (Singapore, Q18 in the inventory), and
// tests fix both.
let nowFn: () => number = () => Date.now();
let zone: string | undefined;           // undefined = the device's local time, like the old app

export const now = () => nowFn();
export function setClock(fn: (() => number) | null) { nowFn = fn ?? (() => Date.now()); }
export function setTimeZone(tz: string | undefined) { zone = tz; partsCache.clear(); }
export const timeZone = () => zone;

const partsCache = new Map<number, [number, number, number]>();
/** Local calendar date [year, month 1-12, day] of a moment. */
export function ymd(ms: number): [number, number, number] {
  if (!zone) { const d = new Date(ms); return [d.getFullYear(), d.getMonth() + 1, d.getDate()]; }
  const hit = partsCache.get(ms);
  if (hit) return hit;
  const p = new Intl.DateTimeFormat('en-CA', { timeZone: zone, year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date(ms));
  const g = (t: string) => +p.find((x) => x.type === t)!.value;
  const r: [number, number, number] = [g('year'), g('month'), g('day')];
  if (partsCache.size > 500) partsCache.clear();
  partsCache.set(ms, r);
  return r;
}
const pad = (n: number) => String(n).padStart(2, '0');
/** The old app's iso(): a moment's local date as YYYY-MM-DD. */
export function isoOf(ms: number): string { const [y, m, d] = ymd(ms); return `${y}-${pad(m)}-${pad(d)}`; }
/** The old app's today(). */
export const today = () => isoOf(now());
/** A calendar date from parts, letting days or months overflow like JavaScript's Date does. */
export function isoFrom(y: number, m: number, d: number): string { return new Date(Date.UTC(y, m - 1, d)).toISOString().slice(0, 10); }
/** Adds whole days to a YYYY-MM-DD date. */
export function addDaysIso(s: string, n: number): string { const [y, m, d] = s.split('-').map(Number); return isoFrom(y, m, d + n); }
/** The old app's "same date last year" (new Date(); setFullYear(-1)): 29 Feb becomes 1 Mar. */
export function yearAgoIso(): string { const [y, m, d] = ymd(now()); return isoFrom(y - 1, m, d); }
/** The old app's days(a, b): days between two YYYY-MM-DD dates (or any Date.parse-able strings). */
export const days = (a: string, b: string) => (Date.parse(b) - Date.parse(a)) / 864e5;
export const currentYear = () => ymd(now())[0];
